module.exports = __webpack_public_path__ + "static/sc_5-961a01447748317641c5d2d8b1329b5f.jpg";